import { render } from "./BulkQuestion.vue?vue&type=template&id=1620c9ac&scoped=true"
import script from "./BulkQuestion.vue?vue&type=script&lang=js"
export * from "./BulkQuestion.vue?vue&type=script&lang=js"

import "./BulkQuestion.vue?vue&type=style&index=0&id=1620c9ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1620c9ac"]])

export default __exports__